<template>
    <div
            style="align-items: flex-start;background:white;max-width: 500px;padding-top: 30px;padding-bottom: 60px;margin: 50px auto;min-height:100px;"
            :class="{ 'tp-payment': true }"
    >
        <div class="tp-payment-container">
            <div>
                <div class="tp-payment-head">
                    <ul class="tp-payment-lang">
                        <li :class="{ active: locale === 'et_EE' }" @click="switchLang('et_EE')">
                            <a href="javascript:{}">EST</a>
                        </li>
                        <li :class="{ active: locale === 'en_GB' }" @click="switchLang('en_GB')">
                            <a href="javascript:{}">ENG</a>
                        </li>
                        <li :class="{ active: locale === 'ru_RU' }" @click="switchLang('ru_RU')">
                            <a href="javascript:{}">RUS</a>
                        </li>
                        <li :class="{ active: locale === 'lv_LV' }" @click="switchLang('lv_LV')">
                            <a href="javascript:{}">LVA</a>
                        </li>
                        <li :class="{ active: locale === 'lt_LT' }" @click="switchLang('lt_LT')">
                            <a href="javascript:{}">LTU</a>
                        </li>
                    </ul>
                    <div class="tp-payment-brand">
                        <label>
                            {{ t("Payment service provided by") }}
                        </label>
                        <img :src="assets_url + '/img/tarkpay-logo.png'"/>
                    </div>
                </div>
            </div>
            <div class="tp-payment-content" style="text-align: center;">
                <p v-if="success && !information">{{
                        t("Action done successfully. You can close this window now.")
                    }}</p>
                <p v-else-if="success && information">{{ t(information) }}</p>
                <p v-else>{{ t("Something went wrong doing action") }}</p>
            </div>
            <div class="tp-payment-foot" v-if="redirectUrl || errorMessage">
                <div class="payment-error" :class="{'mb-3': redirectUrl}" v-if="errorMessage">{{ t(errorMessage) }}</div>
                <button
                        v-if="redirectUrl"
                        class="button-redirect ma-0"
                        type="button"
                        @click="sendToProvider"
                >
                    {{ t(redirectUrlText) }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import settings from "../settings";
import axios from "axios";
export default {
    name: "payment-info-view",
    data() {
        return {
            assets_url: settings.assets_url,
            success: 0,
            errorMessage: "",
            information: "",
            redirectUrl: null,
            redirectUrlText: "",
            locale: 'et_EE',
            translations: []
        };
    },
    async mounted() {
        await this.fetchTranslations(this.locale);
        let uri = window.location.search.substring(1);
        let params = new URLSearchParams(uri);
        if (params.get("success")) {
            this.success = parseInt(params.get("success"));
        }
        if (params.get("msg")) {
            this.errorMessage = params.get("msg");
        }
        if (params.get("info")) {
            this.information = params.get("info");
        }
        if (params.get("url")) {
            this.redirectUrl = params.get("url");
        }
        if (params.get("url_text")) {
            this.redirectUrlText = params.get("url_text");
        }
    },
    methods: {
        sendToProvider() {
            window.location = this.redirectUrl;
        },
        switchLang(locale) {
            this.fetchTranslations(locale);
        },
        async fetchTranslations(locale) {
            let url = settings.assets_url + "/translations/" + locale + ".json";
            let results = await axios.get(url, { withCredentials: false, headers: {} });
            this.locale = locale;
            this.translations = results.data
        },
        t(key) {
            if (this.translations && this.translations[key]) {
                return this.translations[key];
            }
            return key;
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../../vue-embed/src/sass/reset.scss";
@import "../../../vue-embed/src/sass/_fonts.scss";
@import "../../../vue-embed/src/sass/_mixins.scss";
@import "../../../vue-embed/src/sass/_placeholders.scss";
@import "../../../vue-embed/src/sass/_payment-module.scss";
</style>
